import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./uni_profile_links.module.scss";

export const UniProfileLinks = (props) => {
  const { pageData } = props;
  const link = useRouter();
  const { asPath, query } = link;
  const universityName = query.university_name;
  const countryName = query.country_name;
  const courseName = query.course_slug;

  return (
    <section className={styles.section_links}>
      <div className={styles.links_wrapper}>
        <div className="container">
          <div className={styles.links_container}>
            <ul>
              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Overview
                  </a>
                </Link>
              </li>

              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}/admission-faq`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}/admission-faq`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Admission FAQs
                  </a>
                </Link>
              </li>

              {props?.showRankingTab && (
                <li>
                  <Link
                    legacyBehavior
                    href={`/study/${countryName}/university/${universityName}/ranking`}
                  >
                    <a
                      className={`${
                        asPath ===
                        `/study/${countryName}/university/${universityName}/ranking`
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Ranking
                    </a>
                  </Link>
                </li>
              )}

              {props?.showScholarshipTab && (
                <li>
                  <Link
                    legacyBehavior
                    href={`/study/${countryName}/university/${universityName}/scholarships`}
                  >
                    <a
                      className={`${
                        asPath ===
                        `/study/${countryName}/university/${universityName}/scholarships`
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Scholarships
                    </a>
                  </Link>
                </li>
              )}

              {props?.showCourseTab && (
                <li>
                  <Link
                    legacyBehavior
                    href={`/study/${countryName}/university/${universityName}/courses`}
                  >
                    <a
                      className={`${
                        asPath ===
                        `/study/${countryName}/university/${universityName}/courses`
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Courses
                    </a>
                  </Link>
                </li>
              )}

              {asPath ===
                `/study/${countryName}/university/${universityName}/${courseName}` && (
                <li>
                  <Link
                    legacyBehavior
                    href={`/study/${countryName}/university/${universityName}/${countryName}`}
                  >
                    <a
                      className={`${
                        asPath ===
                        `/study/${countryName}/university/${universityName}/${courseName}`
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Course Details
                    </a>
                  </Link>
                </li>
              )}

              {pageData?.length > 0 && (
                <li>
                  <Link
                    legacyBehavior
                    href={`/study/${countryName}/university/${universityName}/blog`}
                  >
                    <a
                      className={`${
                        asPath ===
                        `/study/${countryName}/university/${universityName}/blog`
                          ? `${styles.active}`
                          : ""
                      }`}
                    >
                      Blog
                    </a>
                  </Link>
                </li>
              )}
              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}/staff`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}/staff`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Staff
                  </a>
                </Link>
              </li>

              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}/event-fair`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}/event-fair`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Event/Fair
                  </a>
                </Link>
              </li>

              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}/gallery`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}/gallery`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Gallery
                  </a>
                </Link>
              </li>

              <li>
                <Link
                  legacyBehavior
                  href={`/study/${countryName}/university/${universityName}/contact`}
                >
                  <a
                    className={`${
                      asPath ===
                      `/study/${countryName}/university/${universityName}/contact`
                        ? `${styles.active}`
                        : ""
                    }`}
                  >
                    Contact
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniProfileLinks;
